<template>
  <div>
    <v-form v-model="validForm">
      <v-container fluid grid-list-lg v-if="provider">
        <v-layout row wrap fill-height>
          <v-flex d-flex xs12 md6>
            <v-card style="width: 100%">
              <v-container>
                <v-layout row wrap>
                  <v-flex d-flex xs12 md4 text-center>
                    <td class="px-2 py-3">
                      <v-flex align-center justify-center layout text-center>
                        <v-tooltip right :color="provider.approved ? 'success' : 'error'">
                          <template v-slot:activator="{ on }">
                            <v-badge overlap bottom :color="provider.approved ? 'success' : 'error'">
                              <template v-slot:badge>
                                <v-icon v-on="on" dark slot="badge">{{
                                  provider.approved ? 'done_outline' : 'close'
                                }}</v-icon>
                              </template>
                              <v-avatar v-on="on" :tile="false" :size="130" color="grey lighten-4" class="elevation-5">
                                <img v-if="provider.avatar" :src="provider.avatar" class="cover" alt="" srcset="" />
                                <v-icon v-else color="grey" :size="110">person</v-icon>
                              </v-avatar>
                            </v-badge>
                          </template>
                          <span>{{ provider.approved ? 'Approved' : 'Not yet approve' }}</span>
                        </v-tooltip>
                      </v-flex>
                    </td>
                  </v-flex>
                  <v-flex d-flex xs12 md8>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-flex>
                          <span class="title">{{ provider.fullNameTH }}</span>
                        </v-flex>
                        <v-flex>
                          <span class="title">{{ provider.fullName }}</span>
                        </v-flex>
                        <v-flex>
                          <span>{{ StringUtil.capitalize(provider.type) }}</span>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex d-flex xs12 md6 id="visibility">
            <v-card style="width: 100%">
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card-title class="title"> Visibility </v-card-title>
                  </v-flex>
                  <v-flex xs12 d-inline-flex align-center>
                    <v-flex xs3>
                      <label class="subheading">Hidden</label>
                    </v-flex>
                    <v-flex xs4>
                      <v-switch
                        label="Hidden"
                        color="secondary"
                        value
                        input-value="true"
                        v-model="provider.hidden"
                        hide-details
                        class="mt-0"
                        @change="toggleUpdateProfile()"
                        :loading="loading"
                      ></v-switch>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs12 md6 id="general">
            <v-card>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card-title class="title"> General Information </v-card-title>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="Prefix (EN)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('prefix_en')"
                      data-vv-name="prefix_en"
                      v-model="provider.prefix.en"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="Prefix (TH)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('prefix_th')"
                      data-vv-name="prefix_th"
                      v-model="provider.prefix.th"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="First Name (EN)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('firstname_en')"
                      data-vv-name="firstname_en"
                      v-model="provider.firstname.en"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="First Name (TH)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('firstname_th')"
                      data-vv-name="firstname_th"
                      v-model="provider.firstname.th"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="Last Name (EN)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('lastname_en')"
                      data-vv-name="lastname_en"
                      v-model="provider.lastname.en"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 class="mb-4">
                    <v-text-field
                      type="text"
                      label="Last Name (TH)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('lastname_th')"
                      data-vv-name="lastname_th"
                      v-model="provider.lastname.th"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <!-- HR-only mobile number field. Bound to provider.tel; the transformer's send() function already includes tel in the PATCH payload (lines 367-371 of providerProfile.js). Backend marks tel_confirmed = 1 on save because HR has verified the number out-of-band with the provider's ooca representative.
                  The :rules check enforces international format (must start with + and country code). Empty value is also accepted so HR can clear a number if needed. -->
                  <v-flex xs12 md6 class="mb-4">
                    <v-text-field
                      type="text"
                      label="Mobile Number (verified by ooca representative)"
                      outlined
                      v-validate="''"
                      :rules="telRules"
                      :error-messages="errors.collect('tel')"
                      data-vv-name="tel"
                      v-model="provider.tel"
                      placeholder="+66812345678"
                      hint="Must start with country calling code, e.g. +66 for Thailand, +1 for USA, +44 for UK"
                      persistent-hint
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="Employee Code (Online)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('online_code_name')"
                      data-vv-name="online_code_name"
                      v-model="provider.online_code_name"
                      :hide-details="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 class="mb-4">
                    <v-text-field
                      type="text"
                      label="Employee Code (Offline)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('offline_code_name')"
                      data-vv-name="offline_code_name"
                      v-model="provider.offline_code_name"
                      :hide-details="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      type="text"
                      label="Citizen ID"
                      mask="# #### ##### ## #"
                      disabled
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('citizenid')"
                      data-vv-name="citizenid"
                      v-model="provider.citizenid"
                      :hide-details="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      type="text"
                      label="Passport"
                      disabled
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('passport')"
                      data-vv-name="passport"
                      v-model="provider.passport"
                      :hide-details="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      type="text"
                      label="Gender"
                      disabled
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('gender')"
                      data-vv-name="gender"
                      v-model="provider.gender"
                      :hide-details="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 class="mb-4">
                    <v-text-field
                      type="text"
                      label="Language"
                      disabled
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('language')"
                      data-vv-name="language"
                      :value="ArrayUtil.arrayToText(provider.language)"
                      :hide-details="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      label="Description (EN)"
                      auto-grow
                      outlined
                      :error-messages="errors.collect('description_en')"
                      data-vv-name="description_en"
                      v-model="provider.description_en"
                      :hide-details="true"
                      clearable
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      label="Description (TH)"
                      auto-grow
                      outlined
                      :error-messages="errors.collect('description_th')"
                      data-vv-name="description_th"
                      v-model="provider.description"
                      :hide-details="true"
                      clearable
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 class="mb-4">
                    <v-textarea
                      label="Address"
                      auto-grow
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('address')"
                      data-vv-name="address"
                      v-model="provider.address"
                      :hide-details="true"
                      clearable
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      type="text"
                      label="Slug"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('slug')"
                      data-vv-name="slug"
                      v-model="provider.slug"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="mb-4">
                    <v-text-field
                      type="text"
                      label="Youtube link for self introduction"
                      placeholder="https://www.youtube.com/embed/xxx"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('video_link')"
                      data-vv-name="video_link"
                      v-model="provider.video_link"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="mb-4">
                    <div class="mb-4 title">Preference</div>
                    <v-text-field
                      type="text"
                      label="Quotes (TH)"
                      class="mb-4"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('quotes')"
                      data-vv-name="quotes"
                      v-model="provider.quotes[0].th"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      label="Quotes (EN)"
                      class="mb-4"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('quotes')"
                      data-vv-name="quotes"
                      v-model="provider.quotes[0].en"
                      :hide-details="true"
                      clearable
                    ></v-text-field>
                    <provider-info-list-input
                      v-model="provider.links"
                      :isEnableYear="false"
                      :isEnableEn="false"
                      title="Articles"
                      subtitle="Links to web pages related to the provider"
                      placeholder="https://ooca.co/example-link"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <div class="mb-4 title">Experiences</div>
                    <provider-info-list-input
                      v-model="provider.trainings"
                      title="Training / Certificate"
                      subtitle="Training certificates or courses completed"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <provider-info-list-input
                      v-model="provider.experiences"
                      title="Experiences"
                      subtitle="Professional work experiences or non-profit activities"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <provider-info-list-input
                      v-model="provider.awards"
                      title="Awards"
                      subtitle="Awards and recognitions received"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <div class="mb-4 title">Services</div>
                    <v-select
                      v-model="provider.supported_tests"
                      :items="supportedTestOptions"
                      :menu-props="{ maxHeight: '400' }"
                      label="Test administration privileges"
                      :hide-details="true"
                      multiple
                      outlined
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="provider.supported_services"
                      :items="servicesOptions"
                      :menu-props="{ maxHeight: '400' }"
                      label="Services offered"
                      :hide-details="true"
                      multiple
                      outlined
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="provider.supported_therapies"
                      :items="techniqueOptions"
                      :menu-props="{ maxHeight: '400' }"
                      label="Techniques/Approach used"
                      :hide-details="true"
                      multiple
                      outlined
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="provider.supported_patient_groups"
                      :items="patientGroupOptions"
                      :menu-props="{ maxHeight: '400' }"
                      label="Supported patient group"
                      :hide-details="true"
                      multiple
                      outlined
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Range of ages supported (min - max)"
                      outlined
                      v-validate="''"
                      :error-messages="errors.collect('supported_age_ranges')"
                      data-vv-name="supported_age_ranges"
                      v-model="provider.supported_age_ranges"
                      clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="primary" block :loading="loading" :disabled="!validForm" @click="confirmUpdate()"
                      >SAVE ALL</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex d-flex xs12 md6 align-self-start>
            <v-layout row wrap>
              <v-flex xs12 id="profession">
                <v-card>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="title"> Profession Information </v-card-title>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          v-on:change="changeProviderType"
                          v-model="provider.type"
                          outlined
                          :items="providerTypes"
                          item-text="name_en"
                          item-value="id"
                          label="Provider Type"
                          clearable
                          return-object
                          :hide-details="true"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          v-model="provider.provider_sub_types"
                          outlined
                          :items="providerSubtype"
                          item-text="name_en"
                          item-value="id"
                          label="Provider Subtype"
                          return-object
                          :hide-details="true"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="License Number"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('license_number')"
                          data-vv-name="license_number"
                          v-model="provider.license_number"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          v-model="provider.expertises"
                          outlined
                          :items="providerExpertiseLists"
                          item-text="name_mix"
                          item-value="id"
                          label="Expertise"
                          return-object
                          :hide-details="true"
                          multiple
                          chips
                        ></v-select>
                      </v-flex>
                      <!-- <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Expertise (EN)"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('expertise_en')"
                          data-vv-name="expertise_en"
                          v-model="provider.expertise.en"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Expertise (TH)"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('expertise_th')"
                          data-vv-name="expertise_th"
                          v-model="provider.expertise.th"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex> -->
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Workplaces (EN)"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('workplace')"
                          data-vv-name="workplace"
                          v-model="provider.workplace.en"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Workplaces (TH)"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('workplace')"
                          data-vv-name="workplace"
                          v-model="provider.workplace.th"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="primary" block :loading="loading" :disabled="!validForm" @click="confirmUpdate()"
                          >SAVE ALL</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>

              <v-flex xs12 id="topicTags">
                <v-card>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="title"> Topic Tags </v-card-title>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          class="remove_shadow"
                          v-model="selectedTopic"
                          :items="providerTopics"
                          multiple
                          clearable
                          solo
                        >
                          <template #selection="{ item }">
                            <v-chip
                              color="info"
                              close
                              @click:close="(selectedItem = { type: 'topics', data: item }), (isRemoveModal = true)"
                              >{{ item.text }}</v-chip
                            >
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="primary" block :loading="loading" @click="updateTags('topics')">SAVE ALL</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>

              <v-flex xs12>
                <v-card>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="title"> Provider Tier </v-card-title>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          :items="providerTierLists"
                          v-model="provider.provider_tier_id"
                          outlined
                          :item-text="(item) => `${item.name} (${item.type})`"
                          item-value="id"
                          label="Provider Tier"
                          :hide-details="true"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="primary" block :loading="loading" @click="confirmUpdate()">SAVE ALL</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>

              <v-flex xs12 id="providerTags">
                <v-card>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="title"> Provider Tags </v-card-title>
                      </v-flex>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex xs12>
                        <v-select v-model="selectedTags" :items="providerTags" multiple clearable solo persistent-hint>
                          <template #selection="{ item }">
                            <v-chip
                              style="font-weight: 700; color: #424242"
                              close
                              @click:close="(selectedItem = { type: 'tag', data: item }), (isRemoveModal = true)"
                              >{{ item.text }}</v-chip
                            >
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="primary" block :loading="loading" @click="updateTags('tags')">SAVE ALL</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>

              <v-flex xs12 id="education">
                <v-card>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="title">
                          Education Information
                          <v-icon color="primary" class="ml-2" @click="addEducation">mdi-plus-circle</v-icon>
                        </v-card-title>
                      </v-flex>
                      <v-flex xs12 class="mb-4">
                        <v-data-table :headers="headers" :items="provider.education" hide-default-footer>
                          <template v-slot:body="{ items }">
                            <tbody>
                              <tr v-for="(item, idx) in items" :key="item.id">
                                <td class="text-left">
                                  <v-select
                                    v-model="item.degree"
                                    :items="educationDegreeOptions"
                                    item-text="label"
                                    item-value="value"
                                  ></v-select>
                                </td>
                                <td class="text-left">
                                  <input type="text" class="text-input" v-model="item.curriculum" />
                                </td>
                                <td class="text-left">
                                  <input type="text" class="text-input" v-model="item.curriculumEn" />
                                </td>
                                <td class="text-left">
                                  <input type="text" class="text-input" v-model="item.institute" />
                                </td>
                                <td class="text-left">
                                  <input type="text" class="text-input" v-model="item.instituteEn" />
                                </td>
                                <td class="text-left">
                                  <v-select
                                    v-model="item.country"
                                    :items="countriesOption"
                                    item-text="text"
                                    item-value="value"
                                    hide-details
                                    dense
                                  ></v-select>
                                </td>
                                <td class="text-left">
                                  <input v-model="item.year" type="number" class="education-year" />
                                </td>
                                <td>
                                  <v-icon @click="removeEducation(idx)" color="red">clear</v-icon>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-data-table>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="primary" block :loading="loading" :disabled="!validForm" @click="confirmUpdate()"
                          >SAVE ALL</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>

              <v-flex xs12 id="bank">
                <v-card>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="title"> Bank Information </v-card-title>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Bank Brand"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('bank_brand')"
                          data-vv-name="bank_brand"
                          v-model="provider.bank_brand"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Bank Branch"
                          outlined
                          v-validate="''"
                          :error-messages="errors.collect('bank_branch')"
                          data-vv-name="bank_branch"
                          v-model="provider.bank_branch"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          type="text"
                          label="Bank Account"
                          outlined
                          mask="###-#-#####-#"
                          v-validate="''"
                          :error-messages="errors.collect('bank_account')"
                          data-vv-name="bank_account"
                          v-model="provider.bank_account"
                          :hide-details="true"
                          clearable
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn color="primary" block :loading="loading" :disabled="!validForm" @click="confirmUpdate()"
                          >SAVE ALL</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-dialog v-model="isRemoveModal" width="400">
      <v-card>
        <v-card-title> Remove Tag? </v-card-title>
        <v-card-text>
          Are you sure you want to remove
          {{ selectedItem && selectedItem.data ? selectedItem.data.text : '' }}?
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" text @click="isRemoveModal = false">Cancel</v-btn>
          <v-btn color="error" text @click="removeSelected()">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*eslint-disable no-unused-vars*/
import { Vue } from 'vue-property-decorator';
import loader from '../../utils/loader';
import store from '../../store';
import providerService from '../../services/providerProfiles';
import transformerProvider from '../../transformers/providerProfile';
import formMixins from '../../Mixins/form';
import countryMixins from '../../Mixins/country';
import ArrayUtil from '../../utils/arrayUtil';
import StringUtil from '../../utils/stringUtil';
import providerOptions from '../../constants/providerOptions';

export default Vue.extend({
  store,
  mixins: [formMixins, countryMixins],
  data() {
    return {
      extensionBar: false,
      loading: false,
      provider: null,
      telRules: [
        (value) => {
          // Empty is fine — HR may be intentionally clearing the field.
          if (!value || value.length === 0) return true;
          // Must start with + followed by a country code digit (1-9, no leading zero on a country code).
          if (!/^\+[1-9]\d{6,14}$/.test(value)) {
            return 'Must start with country code, e.g. +66812345678';
          }
          return true;
        },
      ],
      providerSubtype: null,
      validForm: true,
      bottomNav: 'recent',
      disableLicense: true,
      search: '',
      providerHeader: [{ value: 'fullName' }],
      headers: [
        { text: 'Degree', align: 'left', value: 'degree' },
        { text: 'Curriculum (TH)', align: 'left', value: 'curriculum' },
        { text: 'Curriculum (EN)', align: 'left', value: 'curriculumEn' },
        { text: 'Institute (TH)', align: 'left', value: 'institute' },
        { text: 'Institute (EN)', align: 'left', value: 'instituteEn' },
        { text: 'Country', align: 'left', value: 'country' },
        { text: 'Year of Graduation', align: 'left', value: 'year' },
        { text: 'Action', align: 'left', value: 'action' },
      ],
      selectedTopic: [],
      selectedTags: [],
      providerTopics: [],
      providerTags: [],
      isRemoveModal: false,
      selectedItem: null,
      providerTypes: [],
      patientGroupOptions: providerOptions.patientGroupOptions,
      techniqueOptions: providerOptions.techniqueOptions,
      servicesOptions: providerOptions.servicesOptions,
      supportedTestOptions: providerOptions.supportedTestOptions,
      educationDegreeOptions: [
        {
          value: '',
          label: 'None',
        },
        {
          value: 'undergraduate',
          label: 'Undergraduate (ปริญญาตรี)',
        },
        {
          value: 'postgraduate',
          label: 'Postgraduate (ปริญญาโทหรือปริญญาเอก)',
        },
        {
          value: 'diploma',
          label: 'Diploma (ประกาศนียบัตรหรือวุฒิบัตร)',
        },
        {
          value: 'other',
          label: 'Other',
        },
      ],
      providerTierLists: [],
      providerExpertiseLists: [],
    };
  },
  computed: {
    ArrayUtil() {
      return ArrayUtil;
    },
    StringUtil() {
      return StringUtil;
    },
    providerId() {
      return this.$route.params.id;
    },
  },
  watch: {
    providerId() {
      this.getProviderProfile();
      this.resetFormError(null);
    },
  },
  created() {},
  mounted() {
    this.setup();
  },
  methods: {
    setup() {
      this.getProviderProfile();
    },
    viewProfile(id) {
      window.router.push({
        name: 'providerProfile',
        params: {
          id: id,
        },
      });
    },
    changeProviderType() {
      this.provider.type = this.provider.type.name_en.toLowerCase();
      this.selectedSubtypes = [];
      this.getProviderSubtypes(false);
    },
    getProviderProfile() {
      return new Promise((resolve, reject) => {
        providerService
          .fetch(this.providerId)
          .then((data) => {
            this.provider = data;
            // The transformer fetch() copies tel from profile.user.tel. If null (provider has no phone yet), replace with empty string so Vuetify text field renders cleanly and the validation rule treats it as "empty is fine".
            if (!this.provider.tel) {
              this.provider.tel = '';
            }
            if (!this.provider.quotes || this.provider.quotes.length === 0) {
              this.provider.quotes = [{ en: '', th: '' }];
            }

            if (this.provider.provider_sub_types && this.provider.provider_sub_types.length > 0) {
              this.provider.provider_sub_types = this.provider.provider_sub_types[0].provider_types;
            } else {
              this.provider.provider_sub_type = null;
            }

            if (this.provider.expertises && this.provider.expertises.length > 0) {
              this.provider.expertises = this.provider.expertises.map((exp) => {
                return {
                  id: exp.expertise_id,
                  name_mix: exp.name_mix,
                };
              });
            } else {
              this.provider.expertises = [];
            }
            console.log('provider expertise', this.provider.expertises);

            if (this.provider) {
              this.getTopics();
              this.getTags();
              this.getProviderTypes();
              this.getProviderTiers();
              this.getProviderExpertises();
              this.getProviderSubtypes();
            }

            resolve(true);
          })
          .catch((err) => {
            if (err.response && err.response.status === 404) {
              window.router.push({ name: 'notFound' });
            }
            reject(err);
          });
      });
    },
    getProviderTypes() {
      providerService
        .getProviderType()
        .then((res) => {
          this.providerTypes = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProviderSubtypes() {
      providerService
        .getProviderSubtype()
        .then((res) => {
          const parentId = this.provider.type === 'psychiatrist' ? 2 : 1;
          if (this.provider.type) {
            this.providerSubtype = res.filter((subtype) => {
              return subtype.parent_id === parentId;
            });
          } else {
            this.providerSubtype = res;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProviderTiers() {
      providerService
        .getProviderTiers()
        .then((res) => {
          this.providerTierLists = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProviderExpertises() {
      providerService
        .getProviderExpertises()
        .then((res) => {
          this.providerExpertiseLists = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirmUpdate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root
            .$confirm('Update', `Are you sure for update<br/><b>${this.provider.fullName}</b> ?`, {
              color: 'primary',
            })
            .then((confirm) => {
              if (confirm) {
                this.updateProfile();
              }
            });
        }
      });
    },
    updateProfile() {
      this.loading = true;

      if (this.provider.video_link) {
        const youtubeEmbedTemplate = 'https://www.youtube.com/embed/';
        const url = this.provider.video_link.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        const YId = undefined !== url[2] ? url[2].split(/[^0-9a-z_/\\-]/i)[0] : url[0];
        const linkEmbed = youtubeEmbedTemplate.concat(YId);

        this.provider.video_link = linkEmbed;
      }

      providerService
        .newEdit(this.providerId, transformerProvider.send(this.provider))
        .then(() => {
          this.$notify({
            title: 'Update',
            text: 'Update Profile success !!',
            type: 'success',
          });
          this.loading = false;
          // this.getProviderSubtypes();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    toggleUpdateProfile() {
      this.loading = true;
      providerService
        .newEdit(this.providerId, transformerProvider.sendToggle(this.provider))
        .then(() => {
          this.$notify({
            title: 'Update',
            text: 'Update Profile success !!',
            type: 'success',
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTopics() {
      return new Promise((resolve, reject) => {
        providerService
          .fetchAllTopic({
            status: 'approved',
          })
          .then((data) => {
            if (data.data.length < data.meta.pagination.total) {
              providerService
                .fetchAllTopic({
                  per_page: data.meta.pagination.total,
                  page: 1,
                  status: 'approved',
                })
                .then((data2) => {
                  data2.data.forEach((element) => {
                    this.providerTopics.push({
                      text: element.name.en,
                      value: element.id,
                      element: element,
                    });
                  });
                  this.getSelectedTopics();
                })
                .catch((error) => {
                  reject(error);
                });
            } else {
              data.data.forEach((element) => {
                this.providerTopics.push({
                  text: element.name.en,
                  value: element.id,
                  element: element,
                });
              });
              this.getSelectedTopics();
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSelectedTopics() {
      if (this.provider) {
        if (this.provider.topics) {
          this.provider.topics.forEach((element) => {
            let TIndex = this.providerTopics.findIndex((t) => {
              return t.value == element.id;
            });
            if (TIndex > -1) {
              this.selectedTopic.push(this.providerTopics[TIndex].value);
            }
          });
        }
      } else {
        setTimeout(() => {
          if (this.provider) {
            this.getSelectedTopics();
          }
        }, 1000);
      }
    },
    removeSelected() {
      if (this.selectedItem.type == 'topics') {
        let index = this.selectedTopic.indexOf(this.selectedItem.data.value);
        this.selectedTopic.splice(index, 1);
        this.isRemoveModal = false;
      }
      if (this.selectedItem.type == 'subtypes') {
        // let index = this.selectedSubtypes.indexOf(this.selectedItem.data.value);
        // this.selectedSubtypes.splice(index, 1);
        // this.isRemoveModal = false;
      } else {
        let index = this.selectedTags.indexOf(this.selectedItem.data.value);
        this.selectedTags.splice(index, 1);
        this.isRemoveModal = false;
      }
    },
    getTags() {
      return new Promise((resolve, reject) => {
        providerService
          .fetchAllTags({ per_page: 1000, exclude_individual: true })
          .then((data) => {
            if (data.data.length < data.meta.pagination.total) {
              providerService
                .fetchAllTags({ per_page: data.meta.pagination.total, page: 1 })
                .then((data2) => {
                  data2.data.forEach((element) => {
                    this.providerTags.push({
                      text: element.name,
                      value: element.id,
                      element: element,
                    });
                  });
                  this.getSelectedTags();
                })
                .catch((error) => {
                  reject(error);
                });
            } else {
              data.data.forEach((element) => {
                this.providerTags.push({
                  text: element.name,
                  value: element.id,
                  element: element,
                });
              });
              this.getSelectedTags();
            }
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSelectedTags() {
      if (this.provider) {
        if (this.provider.tags) {
          this.provider.tags.forEach((element) => {
            let TIndex = this.providerTags.findIndex((t) => {
              return t.value == element.id;
            });
            if (TIndex > -1) {
              this.selectedTags.push(this.providerTags[TIndex].value);
            }
          });
        }
      } else {
        setTimeout(() => {
          if (this.provider) {
            this.getSelectedTags();
          }
        }, 1000);
      }
    },
    updateTags(tagName) {
      this.loading = true;
      let updateObj = {};
      if (tagName == 'topics') {
        updateObj = {
          topics: this.selectedTopic,
        };
      }
      if (tagName == 'subtypes') {
        // updateObj = {
        //   provider_type_id: this.provider.provider_types.id,
        //   subtypes: this.selectedSubtypes,
        // };
      } else {
        updateObj = {
          tags: this.selectedTags,
        };
      }
      providerService
        .newEdit(this.providerId, updateObj)
        .then(() => {
          let tagArray = [];
          if (tagName == 'topics') {
            this.selectedTopic.forEach((topic) => {
              let TIndex = this.providerTopics.findIndex((t) => {
                return t.value == topic;
              });
              if (TIndex > -1) {
                tagArray.push(this.providerTopics[TIndex].element);
              }
            });
            this.provider.topics = tagArray;
          } else {
            this.selectedTags.forEach((tag) => {
              let TIndex = this.providerTags.findIndex((t) => {
                return t.value == tag;
              });
              if (TIndex > -1) {
                tagArray.push(this.providerTags[TIndex].element);
              }
            });
            this.provider.tags = tagArray;
          }
          this.$notify({
            title: 'Update',
            text: 'Update Profile success !!',
            type: 'success',
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addEducation() {
      this.provider.education.push({
        degree: '',
        curriculum: '',
        curriculumEn: '',
        institute: '',
        instituteEn: '',
        country: '',
        year: new Date().getFullYear(),
      });
    },
    removeEducation(index) {
      this.provider.education.splice(index, 1);
    },
  },
  components: {
    'vertical-tab': loader.component('VerticalTab'),
    'provider-info-list-input': loader.component('ProviderInfoListInput'),
  },
});
</script>

<!-- Add 'scope' attribute to limit CSS to this component only -->
<style>
#topicTags .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
#providerTags .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
#providerSubtype .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.cover {
  object-fit: cover;
}

#education input[type='text'].text-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 4px;
  width: 150px;
}

#education input.education-year {
  width: 70px;
}
</style>
